<mat-form-field appearance="fill" *ngIf="oneOf" class="app-form-control-select">
  <mat-label>{{ label }}</mat-label>
  <mat-select [value]="data" (selectionChange)="onChange($event)">
    <mat-option *ngFor="let option of oneOf" [value]="option.const">
      {{ option.title }}
    </mat-option>
  </mat-select>
</mat-form-field>
